/**
 *  配置入口类
 *
 * @class Config
 */
class Config {
    constructor() {
        // 从 webpack中配置的调式模式
        this.isDebug = process && process.isDebug;
        this.AccessTokenKey = 'CF.AuthToken';
        this.EncryptedAccessTokenKey = 'enc_auth_token';
        this.TwoFactorRememberClientTokenKey = 'TwoFactorRememberClientToken';
        // 远程webpai 访问地址
        this.remoteUrl = window.IPConfig.remoteUrl;
        // 本地 访问地址
        this.baseUrl = window.IPConfig.baseUrl;
        this.defaultPageSize = 10;
        this.tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';
        // this.defaultLocalizationSourceName = 'Auth';
        this.defaultLocalizationSourceName = 'Middleware';
        // this.defaultLocalizationSourceName = 'AspNetZeroDemo';
        this.defaultAdminUserName = 'admin';
        // 当你模拟某个角色或者用户登录后的中转url片段
        this.signInAsSomeoneUrlSegment = 'views/transfer';
        this.BASE_Middle_API = this.remoteUrl + "/api/services/app/";
    }
}

export default new Config();
